var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.51569C10.5698 3.55859 8.8491 3 7 3C4.87259 3 2.91514 3.73938 1.37453 4.97438L1 5.27462V22.0879L2.62547 20.7849C3.82406 19.8241 5.34362 19.25 7 19.25C8.65638 19.25 10.1759 19.8241 11.3745 20.7849L12 21.2863L12.6255 20.7849C13.8241 19.8241 15.3436 19.25 17 19.25C18.6564 19.25 20.1759 19.8241 21.3745 20.7849L23 22.0879V5.27462L22.6255 4.97438C21.0849 3.73938 19.1274 3 17 3C15.1509 3 13.4302 3.55859 12 4.51569ZM3 6.25457V18.1858C4.20526 17.5869 5.56391 17.25 7 17.25C8.43609 17.25 9.79474 17.5869 11 18.1858V6.25457C9.8662 5.46348 8.48833 5 7 5C5.51167 5 4.1338 5.46348 3 6.25457ZM13 6.25457V18.1858C14.2053 17.5869 15.5639 17.25 17 17.25C18.4361 17.25 19.7947 17.5869 21 18.1858V6.25457C19.8662 5.46348 18.4883 5 17 5C15.5117 5 14.1338 5.46348 13 6.25457Z",
    fill: "#697180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.d575e246d0f4bb938d4cd6c67b651be4.svg";
export { ForwardRef as ReactComponent };